// frontend/src/components/error/NotFoundBoundary.tsx
import { Container, Title, Text, Stack } from '@mantine/core';
import { useNavigate } from 'react-router-dom';
import { ActionButton } from '../common/ActionButton';

export function NotFoundErrorBoundary() {
  const navigate = useNavigate();

  return (
    <Container size="md" py="xl">
      <Stack align="center" spacing="xl">
        <Title order={1}>404 - Page Not Found</Title>
        <Text color="dimmed">The page you're looking for doesn't exist.</Text>
        <ActionButton
          onClick={() => navigate('/')}
          label="Return to Home"
          ariaLabel="Return to home page"
          actionType="primary"
        />
      </Stack>
    </Container>
  );
}